import { useContext } from 'react';
import { createContext } from 'react';

import { TotalProductsV2Props } from '../@types/TotalProductsV2Props';

export const TotalProductsV2Context = createContext<TotalProductsV2Props>({} as TotalProductsV2Props);

TotalProductsV2Context.displayName = 'TotalProductsV2';

const TotalProductsV2Provider = (props: TotalProductsV2Props) => (
	<TotalProductsV2Context.Provider value={props}>{props.children}</TotalProductsV2Context.Provider>
);

export const useTotalProductsV2 = () => {
	const context = useContext(TotalProductsV2Context);

	return context;
};

export default TotalProductsV2Provider;
